import type { navCategories, heroArticles } from '@/mocks/home';

interface HeroSectionProps {
  categories: typeof navCategories;
  articles: typeof heroArticles;
}

export default function HeroSection({ categories, articles }: HeroSectionProps) {
  return (
    <section className="relative min-h-[580px] md:min-h-[720px] flex flex-col items-center justify-center overflow-hidden bg-background-100">
      <div className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage: `radial-gradient(circle at 25% 25%, oklch(var(--foreground-950)) 0.5px, transparent 0.5px)`,
          backgroundSize: '40px 40px',
        }}
      ></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-24 pb-0">
        <div className="text-center max-w-[780px] mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            每日持续更新 · 全网最全吃瓜入口
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-950 leading-tight tracking-tight">
            <span className="block">今日看料</span>
            <span className="block mt-2 text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-800">
              全网吃瓜第一入口
            </span>
            <span className="block mt-3 text-lg md:text-xl font-normal text-foreground-500">
              网红塌房 · 明星私聊 · 黑料视频 · 每日更新
            </span>
          </h1>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
            <Link to="/category/heiliao-jinri"
              className="flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即吃瓜
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link to="/category/heiliao-jinri"
              className="flex items-center gap-2 bg-foreground-950 text-background-50 px-8 py-3.5 rounded-full text-base font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line"></i>
              APP 下载
            </Link>
          </div>
        </div>

        <div className="relative mt-12 md:mt-16 pb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-[1000px] mx-auto">
            {articles.map((article, idx) => (
              <Link
                key={article.id}
                to="/category/all"
                className={`group relative rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer ${
                  idx === 1 ? 'md:-mt-8 md:z-20' : idx === 0 ? 'md:rotate-[-2deg] md:z-10' : 'md:rotate-[2deg] md:z-10'
                }`}
              >
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading={idx === 1 ? 'eager' : 'lazy'}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                  <div className="absolute top-3 left-3 flex items-center gap-2">
                    <span className="px-2.5 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium">
                      {article.category}
                    </span>
                    {article.hot && (
                      <span className="px-2 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium flex items-center gap-1">
                        <i className="ri-fire-line text-[10px]"></i>
                        热门
                      </span>
                    )}
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                    <h3 className="text-white text-sm md:text-base font-bold leading-snug line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="mt-2 text-white/60 text-xs line-clamp-1">{article.excerpt}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}